import React from 'react'
import { Drawer, ClickAwayListener , Paper} from '@material-ui/core';
import { AiFillCloseSquare } from 'react-icons/ai';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import './index.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();

const useStyles = makeStyles({
    Paper: {
        backgroundColor: 'rgba(28,28,28,.90)',
    }
})


const NavDrawer = ({ isOpen, onHide }) => {
    const classes = useStyles();
    return (
        <ClickAwayListener onClickAway={onHide}>
            <Drawer
                variant='persistent'
                docked='true'
                anchor='left'
                open={isOpen}
                classes={{paper:classes.Paper}}>
                <div className="drawer-container" >
                    <img data-aos="fade-in" data-aos-duration="500" className="nav-logo" src="./images/stack_logo.png" alt="" />
                    <div data-aos="fade-in" data-aos-duration="500" className="drawer-item">
                        <a onClick={onHide} className="nav-link">Home</a>
                    </div>
                    <div data-aos="fade-in" data-aos-duration="1000" className="drawer-item">
                        <a href="#about-nav" onClick={onHide} className="nav-link">About</a>
                    </div>
                    <div data-aos="fade-in" data-aos-duration="2000" className="drawer-item">
                        <a href="#contact-nav" onClick={onHide} className="nav-link">Contact</a>
                    </div>
                    <div data-aos="fade-in" data-aos-duration="3000" className="drawer-item">
                        <p onClick={onHide} className="nav-link">NFPA Codes</p>
                    </div>
                </div>
                <div className="close-container">
                    <AiFillCloseSquare className="close-symbol" onClick={onHide} />
                </div>
            </Drawer>
        </ClickAwayListener>
    )
}
export default NavDrawer;